import React from 'react';
import AutocompleteSelectFilter from '../Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import { getDesignVersionLabel, shouldShowDesignVersionPicker } from '../../Utils/DocumentVersion/documentDesignVersions.js';

const BASE_OPTION_VALUE = '';

/**
 * Picks which document design renders the generated PDF: the base design (value null) or one
 * of the saved versions. Hidden unless `shouldShowDesignVersionPicker` passes, so the base design is used.
 */
const DesignVersionField = ({ versions, value, onChange, t, direction, className, titleClassName }) => {
    if (!shouldShowDesignVersionPicker(versions)) return null;

    const baseLabel = t('BaseDesign');
    const options = [
        { value: BASE_OPTION_VALUE, label: baseLabel && baseLabel !== 'BaseDesign' ? baseLabel : 'עיצוב בסיסי' },
        ...versions
            .filter((v) => v && v.id != null && v.id !== '')
            .map((v) => ({ value: v.id, label: getDesignVersionLabel(v, t) })),
    ];
    const selected = options.find((o) => o.value === (value || BASE_OPTION_VALUE)) || options[0];

    return (
        <div className={className}>
            <div className={titleClassName}>{t('DesignVersionForDocument')}</div>
            <AutocompleteSelectFilter
                options={options}
                selectedValues={selected}
                onChange={(_, selectedOption) => {
                    if (selectedOption) onChange(selectedOption.value || null);
                }}
                placeholder={t('DesignVersionForDocument')}
                isMultiple={false}
                direction={direction}
                portalMenu
            />
        </div>
    );
};

export default DesignVersionField;
